import { createFileRoute, redirect } from "@tanstack/react-router"
import { getOnboardingFormValues } from "@/features/registration-workflow"
import { SignupDateOfBirthPage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-date-of-birth")({
	beforeLoad: ({ context }) => {
		if (context.userId === null && !getOnboardingFormValues()?.firstName) {
			throw redirect({ to: "/onboarding/name" })
		}
	},
	component: SignupDateOfBirthPage,
})
